import { Head, Link } from '@inertiajs/inertia-vue3';
import Layout from '@/Shared/Layout';
import TextInput from '@/Shared/TextInput';
import SelectInput from '@/Shared/SelectInput';
import LoadingButton from '@/Shared/LoadingButton';
export default {
  components: {
    Head: Head,
    Link: Link,
    LoadingButton: LoadingButton,
    SelectInput: SelectInput,
    TextInput: TextInput
  },
  layout: Layout,
  props: {
    organizations: Array
  },
  remember: 'form',
  data: function data() {
    return {
      form: this.$inertia.form({
        first_name: '',
        last_name: '',
        organization_id: null,
        email: '',
        phone: '',
        address: '',
        city: '',
        region: '',
        country: '',
        postal_code: ''
      })
    };
  },
  methods: {
    store: function store() {
      this.form.post('/contacts');
    }
  }
};